export const CONTRACT_LIST_RETRIEVED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Contract.ContractListRetrieved";

export const CONTRACT_DATA_RETRIEVED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Contract.LeasingOfferContractDataRetrieved";

export const RESTRUCTURING_OFFER_CREATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Contract.RestructuringOfferCreated";
